package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.withFrameNanos

/**
 * Composes [content] only after the first [frames] frames have been drawn, showing [placeholder]
 * (same footprint, so nothing shifts) until then.
 *
 * Use it around below-the-fold blocks that are expensive to bring up — an embedded map view, a
 * strip of remote images, a section that opens its own Firestore stream. The page paints its
 * headline content on frame one instead of paying for everything at once; the deferred blocks land
 * a few frames later, before the user has scrolled to them. Keep [frames] small (2–3): each waits
 * one vsync, and on web a long `withFrameNanos` chain starves the JS thread.
 */
@Composable
fun DeferredContent(
    frames: Int = 2,
    placeholder: @Composable () -> Unit = {},
    content: @Composable () -> Unit,
) {
    var ready by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) {
        repeat(frames) { withFrameNanos { } }
        ready = true
    }
    if (ready) content() else placeholder()
}
